import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../res/translations/messages';

const Spinner = () => (
    <div className="spinner-border spinner-border-sm" role="status"><span className="sr-only"><FormattedMessage {...messages.instance.loading} /></span></div>
);

export default Spinner;
